const unsafeFilenameCharacters = /[\u0000-\u001f\u007f\\/]/;

const normalizeFilename = (value: string | undefined): string | null => {
  const filename = value?.trim();

  if (!filename || unsafeFilenameCharacters.test(filename)) {
    return null;
  }

  return filename;
};

const readDispositionParameters = (header: string): Record<string, string> => {
  const parameters: Record<string, string> = {};
  let position = header.indexOf(';');

  while (position >= 0 && position < header.length) {
    position += 1;

    while (/\s/.test(header[position] ?? '')) {
      position += 1;
    }

    const keyStart = position;
    while (position < header.length && !/[=;\s]/.test(header[position])) {
      position += 1;
    }
    const key = header.slice(keyStart, position).toLowerCase();

    while (/\s/.test(header[position] ?? '')) {
      position += 1;
    }

    if (!key || header[position] !== '=') {
      position = header.indexOf(';', position);
      continue;
    }

    position += 1;
    while (/\s/.test(header[position] ?? '')) {
      position += 1;
    }

    let value = '';
    if (header[position] === '"') {
      position += 1;
      let escaped = false;

      while (position < header.length) {
        const character = header[position];
        position += 1;

        if (escaped) {
          value += character;
          escaped = false;
        } else if (character === '\\') {
          escaped = true;
        } else if (character === '"') {
          break;
        } else {
          value += character;
        }
      }
    } else {
      const valueStart = position;
      const separator = header.indexOf(';', position);
      position = separator < 0 ? header.length : separator;
      value = header.slice(valueStart, position).trim();
    }

    parameters[key] = value;

    if (header[position] !== ';') {
      position = header.indexOf(';', position);
    }
  }

  return parameters;
};

const parseExtendedFilename = (value: string | undefined): string | null => {
  if (!value) {
    return null;
  }

  const match = /^([^']*)'[^']*'(.*)$/.exec(value);
  if (!match || match[1].toLowerCase() !== 'utf-8') {
    return null;
  }

  try {
    return normalizeFilename(decodeURIComponent(match[2]));
  } catch {
    return null;
  }
};

export const parseContentDispositionFilename = (
  header: string | null,
): string | null => {
  if (!header) {
    return null;
  }

  const parameters = readDispositionParameters(header);
  return (
    parseExtendedFilename(parameters['filename*']) ||
    normalizeFilename(parameters.filename)
  );
};

export const getDownloadFilename = (
  fileName: string | undefined,
  header: string | null,
): string => fileName || parseContentDispositionFilename(header) || 'download';
